import { useContext } from "react";
import { useDrop } from "react-dnd";

import styles from "./styles.module.css";
import { PageDisbatch } from "../../../contexts/page";

export default function DropTarget({
  block,
  accept = ["component"],
  path,
  children,
  level,
}) {
  const dispatch = useContext(PageDisbatch);
  const handleDrop = (item, monitor) => {
    if (!monitor.isOver({ shallow: true })) {
      return;
    }

    console.log(monitor.getItem());
    console.log(`move from `, item.path, ` to `, path);

    console.log(accept, item.type);

    dispatch({
      type: "move",
      block: item.block,
      to: [...path],
      from: item.path,
    });
  };

  const [{ isOver, isIn }, dropRef] = useDrop({
    accept: accept,
    drop: handleDrop,
    //hover: handleHover,
    collect: (monitor) => ({
      isOver:
        !!monitor.isOver({ shallow: true }) &&
        accept.includes(monitor.getItem().type),
    }),
    canDrop: (item) => {
      return accept.includes(item.type);
    },
    // hover: (item, monitor) => {
    //   const {top,left} = ref.current.getClientRects();;
    // },
  });
  return (
    <div ref={dropRef}>
      <div
        className={isOver ? styles.dropOver : ""}
        style={{ padding: 2, marginLeft: 8 * level }}
      ></div>
      {children}
    </div>
  );
}
